import * as React from 'react';
import { Skeleton } from '@cian/ui-kit';

import * as styles from './RecommendationSkeleton.css';

export const RecommendationSkeleton: React.FC = () => {
  return (
    <div className={styles['container']}>
      <Skeleton className={styles['image']} borderRadius="var(--unit_3, 12px)" />
      <Skeleton width="100%" height={60} />
    </div>
  );
};
